export default {
    VALIDATION_MSG: {
        NO_SPL_CHARS_ALLOWED: "Please enter a name with only alphanumeric or underscore characters.",
        NO_SPACES_ALLOWED: "Please enter a name without spaces.",
        NO_DUPLICATES_ALLOWED: "This group already exists. Please note that group names are not case sensitive.",
        NO_LONGER_STRINGS_ALLOWED: "Group name too long.",
        NO_NUMBER_FIRST_CHARACTER_ALLOWED: "Please enter a name that does not start with a number."
    }
};
